<div class="textAreaCopyContainer-container" style="margin-bottom: 50px">
  <div class="textAreaCopyContainer" [style]="textAreaCopyContainer.inlineStyle">
    <h3 style="margin-bottom: 0 !important;">{{ textAreaCopyContainer.caption }}</h3>
    <div class="button-container">
      <button class="my-button" (click)="fireCopyEvent($event)">Daten übernehmen</button>
    </div>
    <div class="input-component-container">
      @for (textareas of textAreaCopyContainer.containerList; track $index) {
        @if (layoutElementUtil.isTextArea(textareas)) {
          <div class="input-component">
            <app-text-area
              [textArea]="layoutElementUtil.asTextArea(textareas)">
            </app-text-area>
          </div>
        }
      }
    </div>
  </div>
</div>
